import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
// import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Product, ProductScope, ProductService, RoutingService, TranslatePipe } from '@spartacus/core';
import { CurrentProductService, ProductSummaryComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { NgbAccordionConfig, NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbCollapse, NgbAccordionCollapse, NgbAccordionBody } from '@ng-bootstrap/ng-bootstrap';
import { AsyncPipe } from '@angular/common';
import { ProductSwitchService } from 'src/app/services/kn-br-product-switch.service';

@Component({
    selector: 'kn-br-product-info-detail',
    templateUrl: './kn-br-product-info-detail.component.html',
    styleUrls: ['./kn-br-product-info-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [NgbAccordionConfig],
    imports: [NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbCollapse, NgbAccordionCollapse, NgbAccordionBody, AsyncPipe, TranslatePipe]
})
export class KnBrProductInfoDetailComponent extends ProductSummaryComponent implements OnInit, OnDestroy {
  show = true;
  index;
  openedPanels = ['panel1'];
  pdpProductData;
  subscription: Subscription;
  showProductDetailsAccordion: boolean = false;
  variantProductData;
  product$: Observable<Product | null> = this.currentProductService.getProduct([ProductScope.DETAILS]).pipe(
    tap((_) => {
      this.pdpProductData = _;
      this.knBrCommonService.setSpinner(false);
    })
  );
  constructor(
    protected service: CurrentProductService,
    protected productService: ProductService,
    protected routingService: RoutingService,
    protected cdr: ChangeDetectorRef,
    protected productSwitch: ProductSwitchService,
    private knBrCommonService: KnBrCommonService
  ) {
    super(service);
    //     this.subscription = this.routingService.getRouterState().subscribe((state) => {
    //       if (state.state.params['productCode'])
    // tslint:disable-next-line: max-line-length
    // // TODO:Spartacus - Method 'ProductService.reload' was removed. Please use the reloading triggers configuration instead (see https://sap.github.io/spartacus-docs/loading-scopes/#reloading-triggers for more).
    //         // this.productService.reload(state.state.params['productCode'], ProductScope.DETAILS);
    //     });
    this.knBrCommonService.setSpinner(false);
  }

  ngOnInit(): void {
    this.productSwitch.productVariantCode$.subscribe((variantProductResp) => {
      this.variantProductData = variantProductResp;
      if (variantProductResp) {
        this.showProductDetailsAccordion = true;
      } else {
        this.showProductDetailsAccordion = false;
      }
      this.cdr.detectChanges();
    });
  }

  shouldProductandTechnicalDocumentationDisplay() {
    if (this.pdpProductData) {
      const product = this.pdpProductData;
      if (
        product.assetName ||
        product.assetNameEs ||
        product.assetNameFr ||
        product.productSellSheetName ||
        product.productSellSheetNameEs ||
        product.productSellSheetNameFr ||
        product.safetyAssetName ||
        product.safetyAssetNameEs ||
        product.safetyAssetNameFr
      ) {
        return true;
      }
      return false;
    }
    return false;
  }

  ngOnDestroy() {
    this.showProductDetailsAccordion = false;
    this.subscription?.unsubscribe();
  }
}
